module.exports = __webpack_public_path__ + "img/brand_onboarding_pro_tip.ca4a6a5e.png";